
export default {
  name: 'ContactUs',
  props: {
    numbers: {
      type: Array,
      default: () => []
    }
  }
}
